"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = exports.StringArray = exports.MapRecords = exports.MapRecord = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const any_1 = require("../google/protobuf/any");
function createBaseMapRecord() {
    return { key: "", value: "" };
}
exports.MapRecord = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapRecord();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMapRecord();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseMapRecords() {
    return { records: [] };
}
exports.MapRecords = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.records) {
            exports.MapRecord.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMapRecords();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.records.push(exports.MapRecord.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMapRecords();
        message.records =
            object.records?.map((e) => exports.MapRecord.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStringArray() {
    return { value: [] };
}
exports.StringArray = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.value) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStringArray();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseStringArray();
        message.value = object.value?.map((e) => e) || [];
        return message;
    },
};
function createBaseValue() {
    return { kind: undefined };
}
exports.Value = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.kind?.$case === "intValue") {
            writer.uint32(8).int32(message.kind.intValue);
        }
        if (message.kind?.$case === "longValue") {
            writer.uint32(16).int64(message.kind.longValue);
        }
        if (message.kind?.$case === "floatValue") {
            writer.uint32(29).float(message.kind.floatValue);
        }
        if (message.kind?.$case === "doubleValue") {
            writer.uint32(73).double(message.kind.doubleValue);
        }
        if (message.kind?.$case === "boolValue") {
            writer.uint32(32).bool(message.kind.boolValue);
        }
        if (message.kind?.$case === "stringValue") {
            writer.uint32(42).string(message.kind.stringValue);
        }
        if (message.kind?.$case === "anyValue") {
            any_1.Any.encode(message.kind.anyValue, writer.uint32(50).fork()).ldelim();
        }
        if (message.kind?.$case === "mapValue") {
            exports.MapRecords.encode(message.kind.mapValue, writer.uint32(58).fork()).ldelim();
        }
        if (message.kind?.$case === "intPairValue") {
            writer.uint32(65).fixed64(message.kind.intPairValue);
        }
        if (message.kind?.$case === "stringArrayValue") {
            exports.StringArray.encode(message.kind.stringArrayValue, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.kind = { $case: "intValue", intValue: reader.int32() };
                    break;
                case 2:
                    message.kind = {
                        $case: "longValue",
                        longValue: longToString(reader.int64()),
                    };
                    break;
                case 3:
                    message.kind = { $case: "floatValue", floatValue: reader.float() };
                    break;
                case 9:
                    message.kind = { $case: "doubleValue", doubleValue: reader.double() };
                    break;
                case 4:
                    message.kind = { $case: "boolValue", boolValue: reader.bool() };
                    break;
                case 5:
                    message.kind = { $case: "stringValue", stringValue: reader.string() };
                    break;
                case 6:
                    message.kind = {
                        $case: "anyValue",
                        anyValue: any_1.Any.decode(reader, reader.uint32()),
                    };
                    break;
                case 7:
                    message.kind = {
                        $case: "mapValue",
                        mapValue: exports.MapRecords.decode(reader, reader.uint32()),
                    };
                    break;
                case 8:
                    message.kind = {
                        $case: "intPairValue",
                        intPairValue: longToString(reader.fixed64()),
                    };
                    break;
                case 10:
                    message.kind = {
                        $case: "stringArrayValue",
                        stringArrayValue: exports.StringArray.decode(reader, reader.uint32()),
                    };
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseValue();
        if (object.kind?.$case === "intValue" &&
            object.kind?.intValue !== undefined &&
            object.kind?.intValue !== null) {
            message.kind = { $case: "intValue", intValue: object.kind.intValue };
        }
        if (object.kind?.$case === "longValue" &&
            object.kind?.longValue !== undefined &&
            object.kind?.longValue !== null) {
            message.kind = { $case: "longValue", longValue: object.kind.longValue };
        }
        if (object.kind?.$case === "floatValue" &&
            object.kind?.floatValue !== undefined &&
            object.kind?.floatValue !== null) {
            message.kind = {
                $case: "floatValue",
                floatValue: object.kind.floatValue,
            };
        }
        if (object.kind?.$case === "doubleValue" &&
            object.kind?.doubleValue !== undefined &&
            object.kind?.doubleValue !== null) {
            message.kind = {
                $case: "doubleValue",
                doubleValue: object.kind.doubleValue,
            };
        }
        if (object.kind?.$case === "boolValue" &&
            object.kind?.boolValue !== undefined &&
            object.kind?.boolValue !== null) {
            message.kind = { $case: "boolValue", boolValue: object.kind.boolValue };
        }
        if (object.kind?.$case === "stringValue" &&
            object.kind?.stringValue !== undefined &&
            object.kind?.stringValue !== null) {
            message.kind = {
                $case: "stringValue",
                stringValue: object.kind.stringValue,
            };
        }
        if (object.kind?.$case === "anyValue" &&
            object.kind?.anyValue !== undefined &&
            object.kind?.anyValue !== null) {
            message.kind = {
                $case: "anyValue",
                anyValue: any_1.Any.fromPartial(object.kind.anyValue),
            };
        }
        if (object.kind?.$case === "mapValue" &&
            object.kind?.mapValue !== undefined &&
            object.kind?.mapValue !== null) {
            message.kind = {
                $case: "mapValue",
                mapValue: exports.MapRecords.fromPartial(object.kind.mapValue),
            };
        }
        if (object.kind?.$case === "intPairValue" &&
            object.kind?.intPairValue !== undefined &&
            object.kind?.intPairValue !== null) {
            message.kind = {
                $case: "intPairValue",
                intPairValue: object.kind.intPairValue,
            };
        }
        if (object.kind?.$case === "stringArrayValue" &&
            object.kind?.stringArrayValue !== undefined &&
            object.kind?.stringArrayValue !== null) {
            message.kind = {
                $case: "stringArrayValue",
                stringArrayValue: exports.StringArray.fromPartial(object.kind.stringArrayValue),
            };
        }
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=value.js.map